/**
 * Utilidad para Google reCAPTCHA v3
 * Carga el script de Google de forma dinámica y ejecuta el token invisible de forma segura.
 */

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LcoBuMtAAAAAFMKEfWaJExtK84tA6ozsTQZj261';

let scriptLoaded = false;
let loadPromise = null;

export const loadRecaptchaScript = () => {
  if (!SITE_KEY) {
    return Promise.resolve(null);
  }

  if (scriptLoaded && window.grecaptcha) {
    return Promise.resolve(window.grecaptcha);
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve) => {
    // Si ya existe el script en el DOM
    const existingScript = document.querySelector('script[src*="recaptcha/api.js"]');
    if (existingScript) {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => resolve(window.grecaptcha));
      } else {
        existingScript.addEventListener('load', () => {
          scriptLoaded = true;
          if (window.grecaptcha) {
            window.grecaptcha.ready(() => resolve(window.grecaptcha));
          } else {
            resolve(null);
          }
        });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      scriptLoaded = true;
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          resolve(window.grecaptcha);
        });
      } else {
        resolve(null);
      }
    };
    script.onerror = (err) => {
      console.warn('No se pudo cargar Google reCAPTCHA:', err);
      resolve(null);
    };

    document.head.appendChild(script);
  });

  return loadPromise;
};

/**
 * Ejecuta Google reCAPTCHA v3 para una acción específica y retorna el token.
 * @param {string} action - Nombre de la acción (ej: 'login', 'registro')
 * @returns {Promise<string|null>} Token generado o null si no está configurado/disponible
 */
export const executeRecaptcha = async (action = 'submit') => {
  if (!SITE_KEY) {
    return null;
  }

  try {
    const grecaptcha = await loadRecaptchaScript();
    if (!grecaptcha || typeof grecaptcha.execute !== 'function') {
      return null;
    }
    const token = await grecaptcha.execute(SITE_KEY, { action });
    return token;
  } catch (error) {
    console.warn('Error al ejecutar Google reCAPTCHA v3:', error);
    return null;
  }
};
